import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

/**
 * This middleware make sure that the query param "date" is always set.
 * If it's NOT set we'll try to extract it from the lessonId query param.
 * https://miro.com/app/board/uXjVOPPiOO0=/
 * https://miro.com/app/board/uXjVOCo8R_E=/
 * @param next
 * @param to
 * @param from
 * @param router
 */
export default function timetableCourseDetailsQuery ({ to, from, router }) {
  if (!to.params.lessonId) return

  if (from.query.startDate && from.query.startDate !== to.query.startDate) {
    return { ...to, params: { ...to.params, lessonId: undefined }, name: 'timetable', replace: true }
  }

  const extractedUnix = to.params.lessonId?.split('-')
  const unixMomentDate = GlobalPrototypes.moment.unix(extractedUnix[1])

  // no valid unixDate within lessonId -> go back to prev route
  if (!unixMomentDate.isValid()) return router.go(-1)
}
